import Navbar from './components/Navbar';
import HeroSection from './components/HeroSection';
import TechSpecsSection from './components/TechSpecsSection';
import FormulatorBenefits from './components/FormulatorBenefits';
import SupplyChainSection from './components/SupplyChainSection';
import CTABanner from './components/CTABanner';

export default function Home() {
  return (
    <div className="min-h-screen bg-white" style={{ fontFamily: 'Inter, sans-serif' }}>
      <Navbar />

      <main>
        <section>
          <HeroSection />
        </section>

        <section>
          <TechSpecsSection />
        </section>

        <section>
          <FormulatorBenefits />
        </section>

        <section>
          <SupplyChainSection />
        </section>

        <section>
          <CTABanner />
        </section>
      </main>

      <footer className="bg-[#0F172A] border-t border-white/10 py-6 px-6">
        <div className="max-w-7xl mx-auto flex flex-col sm:flex-row items-center justify-between gap-3">
          <img
            src="https://public.readdy.ai/ai/img_res/edf142ab-b080-49cc-bfe7-ab290dc257ce.png"
            alt="Foraged Fuel"
            className="h-8 w-auto object-contain brightness-0 invert"
          />
          <p className="text-xs text-[#475569] text-center" style={{ fontFamily: 'Inter, sans-serif' }}>
            © {new Date().getFullYear()} Foraged Fuel. All rights reserved. Cordymax™ is a registered trademark.
          </p>
          <a
            href="tel:9548655411"
            className="text-xs text-[#94a3b8] hover:text-white transition-colors whitespace-nowrap cursor-pointer"
            style={{ fontFamily: 'Inter, sans-serif', fontWeight: 600 }}
          >
            (954) 865-5411
          </a>
        </div>
      </footer>
    </div>
  );
}
